module.exports = __webpack_public_path__ + "img/level_center_pointer.6de1794f.png";